import consumerApi from "@/api/services/consumer-api";
import { StrainReview } from "@/custom-types/Reviews";
import { formatSortParam } from "@/utils/formatStrainListFilters";
import logError from "@/utils/logError";

const DEFAULT_PAGE = 1;
const DEFAULT_TAKE = 8;

type StrainReviewsApiResponse = {
  data: StrainReview[];
  metadata: {
    totalCount: number;
  };
};

const getStrainReviews = async (
  slug: string,
  take?: number,
  page?: number,
  sort?: string | string[],
): Promise<StrainReviewsApiResponse> => {
  try {
    const formattedFilter = sort
      ? formatSortParam(sort as string)
      : { "sort[0][rank_score]": "desc" };
    const { data } = await consumerApi.get<StrainReviewsApiResponse>(
      `/api/strains/v1/${slug}/reviews`,
      {
        params: {
          skip: ((page || DEFAULT_PAGE) - 1) * (take || DEFAULT_TAKE),
          take: take || DEFAULT_TAKE,
          ...formattedFilter,
        },
      },
    );

    return data;
  } catch (e) {
    logError(e.message, {
      functionName: "getStrainReviews",
      service: "consumer",
      statusCode: e.statusCode,
    });

    return {
      data: [],
      metadata: {
        totalCount: 0,
      },
    };
  }
};

export default getStrainReviews;
